import { useContext } from 'react';
import ModalContext from './modalContext';

export default function ModalRoot() {
  const { component: Component, props } = useContext(ModalContext);
  return Component ? <Component {...props} /> : null;
}
